module.exports = __webpack_public_path__ + "static/media/martin-knize.bbf86c8b.jpg";